import { createSelector } from "@reduxjs/toolkit";
import { UserInfo } from "Backend";
import { fullNameFromParts } from "helpers/name-helpers";
import { Client, ClientType, UserSession } from "generated/graphql";
import { RootState } from "redux/store";
import RequestStatus from "../RequestStatus";
import { isAdmin, isOwner, isSupport } from "helpers/userHelpers";
import { LocalForageZoom } from "./session.action";

export const selectUserInfo = (state: RootState): UserInfo | undefined => state.session.userInfo;
export const selectSession = (state: RootState): UserSession | undefined => state.session.session;
export const selectClient = (state: RootState): Client | undefined => state.session.client;
export const selectSessionStatus = (state: RootState): RequestStatus => state.session.status;
export const selectHiddenCellIds = (state: RootState): number[] => state.session.hiddenCellIds;
export const selectSavedZoom = (state: RootState): LocalForageZoom => ({
  scale: state.session.savedZoomScale,
  option: state.session.savedZoomOption,
});
export const selectPermissions = createSelector([selectSession], (session) => session?.permissions);
export const selectIsSupport = createSelector([selectPermissions], (permissions) => {
  if (!permissions) return false;
  return isSupport(permissions);
});
export const selectIsOwner = createSelector([selectPermissions], (permissions) => {
  if (!permissions) return false;
  return isOwner(permissions);
});
export const selectIsAdmin = createSelector([selectUserInfo], (userInfo) => {
  if (!userInfo) return false;
  return isAdmin(userInfo);
});
export const selectCollectEnabled = (state: RootState): boolean => state.session.client?.collectEnabled ?? false;

export const selectIsOwnerOrSupport = createSelector([selectIsOwner, selectIsSupport], (isOwner, isSupport) => {
  return isOwner || isSupport;
});
export const selectMyUserType = createSelector([selectUserInfo], (userInfo) => userInfo?.userType);
export const selectMyUserId = createSelector([selectSession], (session) => session?.userId);
export const selectMyUsersName = createSelector([selectUserInfo], (userInfo) =>
  fullNameFromParts(userInfo?.firstName, userInfo?.lastName)
);
export const selectClientType = createSelector([selectClient], (client) => client?.clientType);
export const selectIsPlaintiffFirm = createSelector(
  [selectClientType],
  (clientType) => clientType === ClientType.PlaintiffFirm
);
export const selectEnableFirmFeatureSet = createSelector(
  [selectClientType],
  (clientType) => clientType === ClientType.DefenseFirm || clientType === ClientType.Administrator
);
